import { render, staticRenderFns } from "./UsersGroupsList.vue?vue&type=template&id=8271c894&"
import script from "./UsersGroupsList.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports